module.exports = {
  "env": {},
  "webpackDevMiddleware": null,
  "eslint": {"ignoreDuringBuilds": false},
  "typescript": {"ignoreBuildErrors": false, "tsconfigPath": "tsconfig.json"},
  "distDir": "./.next",
  "cleanDistDir": true,
  "assetPrefix": "",
  "configOrigin": "next.config.js",
  "useFileSystemPublicRoutes": true,
  "generateEtags": true,
  "pageExtensions": ["tsx", "ts", "jsx", "js"],
  "target": "server",
  "poweredByHeader": true,
  "compress": true,
  "analyticsId": "",
  "images": {
    "deviceSizes": [640, 750, 828, 1080, 1200, 1920, 2048, 3840],
    "imageSizes": [16, 32, 48, 64, 96, 128, 256, 384],
    "path": "/_next/image",
    "loader": "default",
    "domains": [],
    "disableStaticImages": false,
    "minimumCacheTTL": 60,
    "formats": ["image/webp"],
    "dangerouslyAllowSVG": false,
    "contentSecurityPolicy": "script-src 'none'; frame-src 'none'; sandbox;"
  },
  "devIndicators": {"buildActivity": true, "buildActivityPosition": "bottom-right"},
  "onDemandEntries": {"maxInactiveAge": 15000, "pagesBufferLength": 2},
  "amp": {"canonicalBase": ""},
  "basePath": "",
  "sassOptions": {},
  "trailingSlash": false,
  "i18n": null,
  "productionBrowserSourceMaps": false,
  "optimizeFonts": true,
  "excludeDefaultMomentLocales": true,
  "serverRuntimeConfig": {},
  "publicRuntimeConfig": {},
  "reactStrictMode": false,
  "httpAgentOptions": {"keepAlive": true},
  "outputFileTracing": true,
  "staticPageGenerationTimeout": 60,
  "swcMinify": false,
  "output": "standalone",
  "experimental": {
    "manualClientBasePath": false,
    "legacyBrowsers": true,
    "browsersListForSwc": false,
    "newNextLinkBehavior": false,
    "cpus": 7,
    "sharedPool": true,
    "profiling": false,
    "isrFlushToDisk": true,
    "workerThreads": false,
    "pageEnv": false,
    "optimizeCss": false,
    "nextScriptWorkers": false,
    "scrollRestoration": false,
    "externalDir": false,
    "disableOptimizedLoading": false,
    "gzipSize": true,
    "swcFileReading": true,
    "craCompat": false,
    "esmExternals": true,
    "appDir": false,
    "isrMemoryCacheSize": 52428800,
    "incrementalCacheHandlerPath": "/Users/shitizg/Documents/aaco/app/utils/isr-cache.js",
    "serverComponents": false,
    "fullySpecified": false,
    "outputFileTracingRoot": "",
    "images": {"remotePatterns": []},
    "swcTraceProfiling": false,
    "forceSwcTransforms": false,
    "largePageDataBytes": 128000,
    "trustHostHeader": false
  },
  "configFileName": "next.config.js"
};
